module.exports = __webpack_public_path__ + "static/media/background_parking.2eb8236b.jpg";